import React from "react";
import { SendConfirmationModal } from "../../../SendConfirmationModal";
import { useClarificationsRegisterContext } from "../ClarificationsRegisterContext";

export const SendModalWrapper: React.FC = () => {
  const { selection, modals } = useClarificationsRegisterContext();
  const { selectedItemsForSending, supplierNameForSend } = selection;
  const { isSendModalOpen, setIsSendModalOpen, isSending, handleConfirmSend } = modals;

  return (
    <SendConfirmationModal
      isOpen={isSendModalOpen}
      onClose={() => setIsSendModalOpen(false)}
      onConfirm={handleConfirmSend}
      clarifications={selectedItemsForSending}
      supplierName={supplierNameForSend}
      isLoading={isSending}
    />
  );
};
